import getAppUrlBase from './getAppUrlBase';

export default surveySlug => `${getAppUrlBase()}${surveySlug}`;
